import React from 'react'
import SubcategoryEdit from './SubcategoryEdit'
const EditSubCategory = () => {
    return (
        <SubcategoryEdit />
    )
}

export default EditSubCategory